import { GithubEntityType, ScmType } from "@protos/common/v1/common";
import { ScmApp, ScmConfig } from "@protos/scm/v1/scm";

// user signed in with GitHub
export const SCM_GITHUB_USER: ScmConfig = {
  id: 280,
  type: ScmType.GITHUB,
  namespace: "TestSemgrep",
  sourceId: "71473284",
  baseUrl: "https://github.com",
  status: { checked: new Date("2024-06-03T12:38:12.000Z"), ok: true },
  installed: false,
  suspended: false,
  githubEntityType: GithubEntityType.UNSPECIFIED,
  scmId: 260,
};
export const SCM_GITHUB_USER_2: ScmConfig = {
  id: 281,
  type: ScmType.GITHUB,
  namespace: "TestSemgrep2",
  sourceId: "71473285",
  baseUrl: "https://github.com",
  status: { checked: new Date("2024-06-03T12:38:12.000Z"), ok: true },
  installed: false,
  suspended: false,
  githubEntityType: GithubEntityType.UNSPECIFIED,
  scmId: 261,
};
export const SCM_GITLAB_USER: ScmConfig = {
  id: 282,
  type: ScmType.GITLAB,
  namespace: "TestSemgrep",
  sourceId: "71473284",
  baseUrl: "https://gitlab.com",
  status: { checked: new Date("2024-06-03T12:38:12.000Z"), ok: true },
  installed: false,
  suspended: false,
  githubEntityType: GithubEntityType.UNSPECIFIED,
  scmId: 262,
};

export const SCM_GITLAB_USER_2: ScmConfig = {
  id: 283,
  type: ScmType.GITLAB,
  namespace: "TestSemgrep",
  sourceId: "71473284",
  baseUrl: "https://gitlab.com",
  status: { checked: new Date("2024-06-03T12:38:12.000Z"), ok: true },
  installed: false,
  suspended: false,
  githubEntityType: GithubEntityType.UNSPECIFIED,
  scmId: 263,
};

// user signed in with GitHub and has code access
export const SCM_APP_CODE_ACCESS: ScmApp = {
  id: 1,
  slug: "app-slug",
  appId: 2234,
  scmType: ScmType.GITHUB,
  baseUrl: "github.com",
  requestId: "app-request-id",
  scmName: "app-scm-name",
  codeAccess: true,
};

export const SCM_GITHUB_CODE_ACCESS: ScmConfig = {
  id: 1,
  type: ScmType.GITHUB,
  namespace: "scm-namespace",
  sourceId: "scm-source-id",
  baseUrl: "github.com",
  app: SCM_APP_CODE_ACCESS,
  status: { ok: true, checked: undefined },
  installed: true,
  suspended: false,
  githubEntityType: GithubEntityType.ORG,
  scmId: 1,
};
